/**
 * Defines the intent context payload in the speech.context message
 */
export interface Intent {
    /**
     * The intent provider (LUIS or CLU)
     */
    provider?: string;

    /**
     * The intent provider identifier. For CLU this is the projectName.
     */
    id?: string;

    /**
     * The Endpoint for LUIS or CLU (optional).
     */
    endpoint?: string;

    /**
     * The Deployment name for CLU (optional).
     */
    deploymentName?: string;

    /**
     * The language resource key for CLU (optional).
     */
    languageResource?: string;
}
